import PropTypes from 'prop-types'
import easydropdown from 'easydropdown'
import { useEffect, useRef } from 'react'

function Sort({ name, value, handleFilter }) {
  const ref = useRef()
  const eddRef = useRef()

  useEffect(() => {
    if (ref.current) {
      const edd = easydropdown(ref.current, {
        behavior: {
          liveUpdates: true,
        },
      })

      eddRef.current = edd

      ref.current.addEventListener('change', (e) => {
        handleFilter(e.target.name, e.target.value)
      })
    }

    return () => {
      eddRef.current.destroy()
    }
  }, [ref])

  return (
    <form className="flex items-center styled-form md:w-80">
      <label htmlFor="listings-sort" className="flex-shrink-0 mr-4 font-normal">
        Sort by:
      </label>
      <select id="listings-sort" name={name} ref={ref} value={value} onChange={() => {}}>
        <option value="rel">Relevance</option>
        <option value="name_asc">Name (A-Z)</option>
        <option value="name_decc">Name (Z-A)</option>
      </select>
    </form>
  )
}

Sort.propTypes = {
  name: PropTypes.string,
  value: PropTypes.string,
  handleFilter: PropTypes.func,
}

export default Sort
